import styled, { css } from 'styled-components';

const VERTICAL = 'vertical';
const NEUTRAL = 'neutral';
function isVertical(orientation) {
    return orientation === VERTICAL;
}
const StyledTimeline = styled.div(({ orientation = VERTICAL }) => css `
    display: flex;
    flex-direction: ${isVertical(orientation) ? 'column' : 'row'};
  `);
const StyledTimelineItem = styled.div(({ orientation = VERTICAL }) => css `
    padding: 8px;
    position: relative;

    ${isVertical(orientation) &&
    css `
      &:first-child > div > main::before {
        position: relative;
      }
      &:first-child > div > main::after {
        height: 50%;
      }
      &:last-child > div > main::before {
        height: 50%;
      }
      &:last-child > div > main::after {
        position: relative;
      }
    `}

    ${!isVertical(orientation) &&
    css `
      &:first-child > div > main::after {
        transform: translate(0%, 50%);
      }
      &:first-child:is(:only-child) > div > main::after {
        width: 0;
      }
      &:last-child > div > main::after {
        transform: translate(-100%, 50%);
      }
    `}
  `);
const TimelineContent = styled.div(({ orientation = VERTICAL }) => css `
    display: grid;

    ${isVertical(orientation) &&
    css `
      grid-template-areas: 'before dot after';
      grid-template-columns: 1fr 10px 1fr;
    `}

    ${!isVertical(orientation) &&
    css `
      grid-template-columns: 'before dot after';
      grid-template-rows: 1fr 10px 1fr;
    `}

    gap: 12px;
    row-gap: 12px;
  `);
const TimelineBefore = styled.aside(({ orientation = VERTICAL, theme: { olist: theme } }) => css `
    grid-area: 'before';
    justify-self: ${theme.components.timeline.orientation[orientation]
    .justifyBefore};
    align-self: center;
  `);
const TimelineAfter = styled.aside(({ orientation = VERTICAL, theme: { olist: theme } }) => css `
    grid-area: 'after';
    justify-self: ${theme.components.timeline.orientation[orientation]
    .justifyAfter};
    align-self: center;
  `);
const LineArea = styled.main(({ orientation = VERTICAL, theme: { olist: theme } }) => css `
    grid-area: 'dot';
    text-align: center;
    justify-self: center;
    align-self: center;

    &::after,
    &::before {
      content: '';
      position: absolute;
      width: ${theme.components.timeline.orientation[orientation].afterWidth};
      height: ${theme.components.timeline.orientation[orientation].afterHeight};
      background-color: ${theme.color.neutral.base};
      transform: ${theme.components.timeline.orientation[orientation]
    .afterTransform};
      z-index: -1;
    }

    ${!isVertical(orientation) &&
    css `
      &::after {
        bottom: 50%;
      }
      &::before {
        width: 0;
      }
    `}
  `);
const Dot = styled.div(({ variation = NEUTRAL, theme: { olist: theme } }) => css `
    width: 10px;
    height: 10px;
    background-color: ${theme.components.timeline.variation[variation]};
    border-radius: 50%;
  `);
const DoubleDot = styled.div(({ variation = NEUTRAL, theme: { olist: theme } }) => css `
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: ${theme.color.neutral.softest};
    border-radius: ${theme.borderRadius.circle};
    border: 1px solid ${theme.components.timeline.variation[variation]};

    width: 16px;
    height: 16px;

    &:before {
      content: '';
      width: 10px;
      height: 10px;
      border-radius: ${theme.borderRadius.circle};
      background-color: ${theme.components.timeline.variation[variation]};
    }
  `);

export { Dot, DoubleDot, LineArea, StyledTimeline, StyledTimelineItem, TimelineAfter, TimelineBefore, TimelineContent };
